import { useTranslate } from "ra-core";
import { Link } from "react-router";
import { useIsMobile } from "@/hooks/use-mobile";

import { CulturePage } from "../culture/CulturePage";
import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { MobileBackButton } from "../misc/MobileBackButton";
import { OrgChartPage } from "../orgchart/OrgChartPage";

/**
 * Almikia Epic EO (TASK-098): the "Almikia" section landing, one tap away
 * from the desktop rail / mobile bottom navigation for every one of the 8
 * roles. Offers "Organigrama" and "Nuestra cultura" (TASK-099) as entries.
 */
export const AlmikiaPage = () => {
  const translate = useTranslate();
  const isMobile = useIsMobile();

  const body = (
    <ul className="flex flex-col gap-3">
      <li>
        <Link
          to={OrgChartPage.path}
          className="flex min-h-11 items-center justify-between gap-3 rounded-2xl bg-card p-4 text-base font-semibold shadow-sm focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-brand-yellow"
        >
          {translate("crm.almikia.organigrama_entry")}
        </Link>
      </li>
      <li>
        <Link
          to={CulturePage.path}
          className="flex min-h-11 items-center justify-between gap-3 rounded-2xl bg-card p-4 text-base font-semibold shadow-sm focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-brand-yellow"
        >
          {translate("crm.almikia.cultura_entry")}
        </Link>
      </li>
    </ul>
  );

  if (isMobile) {
    return (
      <>
        <MobileHeader>
          <MobileBackButton to="/" />
          <div className="flex flex-1 min-w-0">
            <h1 className="text-xl font-semibold truncate">
              {translate("crm.almikia.title")}
            </h1>
          </div>
        </MobileHeader>
        <MobileContent>{body}</MobileContent>
      </>
    );
  }

  return (
    <div className="mx-auto flex max-w-xl flex-col gap-4 p-4">
      <h1 className="text-2xl font-bold">{translate("crm.almikia.title")}</h1>
      {body}
    </div>
  );
};

AlmikiaPage.path = "/almikia";
